import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo,
  faEye,
  faVideoSlash,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

function CustomButton({
  title,
  eyeIcon,
  addIcon,
  endCameraIcon,
  startLiveIcon,
  text,
  textStartLive,
  textDetails,
  textCreateLive,
  onClick,
  icon
}) {
  return (
    <div>
      {" "}
      <button
      onClick = { onClick }
        style={{
          background: textCreateLive ? "#422F90" : "#F7F7F7",
          color: endCameraIcon
            ? " #D21C1C"
            : startLiveIcon
              ? "#422F90"
              : textDetails
                ? "#422F90"
                : textCreateLive
                  ? "#fff"
                  : "#422F90",
          fontSize: endCameraIcon ? "16px" : "",
          border: text
            ? "1px solid #D21C1C "
            : textStartLive
              ? "1px solid #422F90"
              : textDetails
                ? "1px solid #422F90"
                : "",
          borderRadius: "6px",
          padding: "20px 0px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: textDetails ? "120px" : "99px",
          height: "36px",
          minWidth: "110px",
          textDecoration: addIcon ? "none" : "",
        }}
      >
        {startLiveIcon && <FontAwesomeIcon icon={faVideo} />}
        {endCameraIcon && <FontAwesomeIcon icon={faVideoSlash} />}
        {eyeIcon && <FontAwesomeIcon icon={faEye} />}
        {addIcon && <FontAwesomeIcon icon={faPlus} />}
        {icon}
        &nbsp; {text} {textStartLive}
        {textDetails}
        {textCreateLive}
      </button>
    </div>
  );
}

export default CustomButton;
